<template>
  <div>
    <el-container>
      <el-main sytle="margin:0px;padding:0px;">
        <el-row style="margin-top:0px,padding-top:0px;">
          <span style="font-size: 22px;">资质证书</span>
        </el-row>
        <el-row>
          <el-col :span="24">
            <img width="240px" height="160px" src="@/assets/image/zhizhao.png">
          </el-col>
        </el-row>
        <el-row>
          <span style="font-size: 22px;">专利证书</span>
        </el-row>
        <el-row>
         暂无
        </el-row>
        <el-row>
          <span style="font-size: 22px;">软件著作权</span>
        </el-row>
        <el-row>
          暂无
        </el-row>
        <el-row>
          <span style="font-size: 22px;">获奖证书</span>
        </el-row>
        <el-row>
            暂无
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'qualificationPage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.el-main {
  margin: 10px;
  padding: 10px;
  height: 500px;
}
.el-row {
  margin-top: 10px;
  padding-left: 10px;
  text-align: left;
}
</style>
